import { render, staticRenderFns } from "./contractStandard.vue?vue&type=template&id=f88b27e4&scoped=true"
import script from "./contractStandard.vue?vue&type=script&lang=js"
export * from "./contractStandard.vue?vue&type=script&lang=js"
import style0 from "./contractStandard.vue?vue&type=style&index=0&id=f88b27e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88b27e4",
  null
  
)

export default component.exports